import moment from 'moment'

/**
 * The purpose of this class is to handle opening time details for a given date.
 */
export default class OpeningTimes {
    constructor(days, overrides) {
        this.days = days;
        this.overrides = overrides;
    }

    /**
     * Retrieves opening time details for a given date.
     * @param {String} date - The date for which opening details are to be retrieved.
     * @returns {Object|boolean} - Opening time details or false if not found.
     */
    details(date) {
        const details = this.getOpeningTimeDetails(date);

        if (details) {
            const { opening_time_start, opening_time_end, opening_time_closed, opening_time_note } = details;
            return {
                status: this.toString(opening_time_closed, opening_time_start, opening_time_end),
                note: opening_time_note
            };
        }

        return false;
    }

    /**
     * Retrieves opening details for a given date.
     * @param {String} date - The date for which opening details are to be retrieved.
     * @returns {Object|boolean} - Opening details or false if not found.
     */
    getOpeningTimeDetails(date) {
        const dateKey = moment.utc(date).format('DD/MM/YYYY');
        const override = this.overrides[dateKey];

        if (override) {
            return override;
        }

        const dayOfWeek = moment.utc(date).format('dddd').toLowerCase();
        const day = this.days['opening_times_' + dayOfWeek];

        return day || false;
    }

    /**
     * Returns the opening times as a string.
     * @param {String} start - Opening time start.
     * @param {String} end - Opening time end.
     * @returns {String} - Opening times as a string.
     */
    toString(closed, start, end) {
        if (closed || (start?.length === 0 && end?.length === 0)) {
            return 'Closed.';
        }

        const startTime = start.replace(':00', '');
        let endTime = end === '12:00 am' ? 'Midnight' : end;
        endTime = endTime.replace(':00', '');

        return `Open ${startTime} - ${endTime}.`;
    }
}
